import { useState } from "react";
import "./login.scss";
import { useFormik } from "formik";
import Notiflix from "notiflix";
import { createData } from "./apollo";
import { useMutation } from "@apollo/client";
import { messageError, messageSuccess } from "../../helper";
import { url_path_files } from "../../helper/url";
import compressImage from "../../helper/uploadFile";
import PDF_REGISTER from "../../img/P-HR-014 ໃບສະຫມັກວຽກ .pdf";
import { gcpUpload } from "../../helper/gcpUpload";
import logo_next_day from "../../img/logo_next_day.png";
import background from "../../img/background-red-white.jpg";
//component form  sections
import BasicInfoSection from "./BasicInfoSection";
import RelativeContactSection from "./RelativeContactSection";
import ExtraTables from "./ExtraTables";
import IdentityAndReasonSection from "./IdentityAndReasonSection";

export default function FormRegister() {
  const [addData] = useMutation(createData);
  const [imageCV, setImageCV] = useState("");
  const [imagePR, setImagePR] = useState("");
  const [getFile, setFile] = useState("");
  const [salaryPrevDisplay, setSalaryPrevDisplay] = useState("");
  const [salaryReqDisplay, setSalaryReqDisplay] = useState("");
  const formatSalary = (numStr = "") => {
    const digitsOnly = numStr.replace(/\D/g, "");
    if (!digitsOnly) return "";
    return digitsOnly.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  };

  const handleChangeFileProfile = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    try {
      if (!file.type.startsWith("image/")) {
        messageError("ກະລຸນາເລືອກເອກະສານຮູບພາບ");
        return;
      }
      const compressedFile = await compressImage(file);
      const reader = new FileReader();
      reader.onload = async (e) => {
        setImagePR(e.target?.result);
        const res = await gcpUpload({
          file: compressedFile,
          bucketName: "anousith-bucket",
          pathname: "user-register",
          filename: compressedFile.name,
        });
        if (res?.publicUrl) {
          setImagePR(res?.filename);
        }
      };
      reader.readAsDataURL(compressedFile);
    } catch (error) {
      console.error(error);
      messageError("ອັບໂຫຼດບໍ່ສຳເລັດ");
    }
  };

  const handleChangeFile = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    const isPDF = file.type === "application/pdf";
    const isImage = file.type.startsWith("image/");
    if (!isPDF && !isImage) {
      messageError("ຂະລຸນາເລືອກເອກະສານທີ່ຮອງຮັບ (PDF ຫຼື ຮູບພາບ)");
      return;
    }

    try {
      const uploadFile = isImage ? await compressImage(file) : file;

      // preview (for images)
      const reader = new FileReader();
      reader.onload = async (ev) => {
        if (isImage) {
          setImageCV(ev.target?.result || "");
        }
        setFile(file.name);

        try {
          const res = await gcpUpload({
            file: uploadFile,
            bucketName: "anousith-bucket",
            pathname: "user-register",
            filename: uploadFile.name,
          });

          const saved = res?.publicUrl || res?.filename || "";
          if (saved) {
            setImageCV(saved);
          }
        } catch (err) {
          console.error(err);
          messageError("ອັບໂຫຼດບໍ່ສຳເລັດ");
        }
      };

      reader.readAsDataURL(uploadFile);
    } catch (error) {
      console.error(error);
      messageError("ອັບໂຫຼດບໍ່ສຳເລັດ");
    }
  };

  const formatEducationLevelString = (rows = []) => {
    const filled = Array.isArray(rows)
      ? rows.filter(
          (arr) =>
            Array.isArray(arr) && arr.some((v) => String(v ?? "").trim() !== "")
        )
      : [];

    return filled
      .map((arr, idx) => {
        const [level = "", inst = "", subj = "", year = "", grade = ""] =
          arr.map((v) => String(v ?? "").trim());
        const n = idx + 1;
        return `(${n}. index1:${level}, index2:${inst}, index3:${subj}, index4:${year}, index5:${grade})`;
      })
      .join(",");
  };

  const formatPreviousWorkString = (rows = []) => {
    const filled = Array.isArray(rows)
      ? rows.filter(
          (arr) =>
            Array.isArray(arr) && arr.some((v) => String(v ?? "").trim() !== "")
        )
      : [];

    return filled
      .map((arr, idx) => {
        const [place = "", position = "", task = "", reason = "", exp = ""] =
          arr.map((v) => String(v ?? "").trim());
        const n = idx + 1;
        return `(${n}. index1:${place}, index2:${position}, index3:${task}, index4:${reason}, index5:${exp})`;
      })
      .join(",");
  };

  // ===== useFormik =====
  const {
    handleChange,
    errors,
    values,
    handleSubmit,
    isSubmitting,
    resetForm,
    validateForm,
    setTouched,
    setFieldValue,
  } = useFormik({
    initialValues: {
      imagePR: "",
      firstName: "",
      lastName: "",
      phoneNumber: "",
      profileImage: "",
      files: "",
      position: "",
      dateOfBirth: "",
      description: "",
      educationLevel: [
        ["", "", "", "", ""], // [educationLevel, educationalInstitution, subject, academicYear, grade]
        ["", "", "", "", ""],
        ["", "", "", "", ""],
      ],
      previousPlaceOfWork: [
        ["", "", "", "", ""], // [previousPlaceOfWork, oldPosition, responsibilities, reasonForResignation, workExperience]
        ["", "", "", "", ""],
        ["", "", "", "", ""],
      ],
      computerSkills: "",
      otherComputerSkills: "",
      englishSkills: "",
      chineseSkills: "",
      vietnamSkills: "",
      otherSkills: "",
      nationality: "",
      tribe: "",
      religion: "",
      ready: "",
      recruitmentNew: "",
      previousSalary: "",
      requiredSalary: "",
      village: "",
      district: "",
      province: "",
      villageNew: "",
      districtNew: "",
      provinceNew: "",
      statusPerson: "",
      detailStatusOther: "",
      censusNumber: "",
      censusDate: null,
      leaveBy: "",
      identityCardNumber: "",
      dateCard: null,
      leaveByCard: "",
      reasontobecome: "",
      specialSkillOther: "",
      relativeBy: "",
      relationship: "",
      relativePhone: "",
      relativeVillage: "",
      relativeDistrict: "",
      relativeProvince: "",
    },
    enableReinitialize: false,
    validate: (values) => {
      const errors = {};
      //validate
      if (!values.firstName) errors.firstName = "ກະລຸນາປ້ອນຊື່";
      if (!values.lastName) errors.lastName = "ກະລຸນາປ້ອນນາມສະກຸນ";

      /* phoneNumber */
      if (!values.phoneNumber) {
        errors.phoneNumber = "ກະລຸນາປ້ອນເບີໂທ";
      } else if (!/^\d+$/.test(values.phoneNumber)) {
        errors.phoneNumber = "ເບີໂທຕ້ອງເປັນຕົວເລກເທົ່ານັ້ນ";
      } else if (!/^\d{8,12}$/.test(values.phoneNumber)) {
        errors.phoneNumber = "ເບີໂທບຸກຄົນຕິດຕໍ່ບໍ່ຖືກຮູບແບບ (8-12 ໂຕເລກ)";
      } else if (/^0/.test(values.phoneNumber)) {
        errors.phoneNumber = "ເບີໂທຫ້າມເລີ່ມຕົ້ນດ້ວຍ 0";
      }

      if (!values.files && !imageCV) {
        errors.files = "ກະລຸນາອັບໂຫຼດເອກະສານ CV (PDF ຫຼື ຮູບພາບ)";
      } else {
        delete errors.files;
      }
      if (!values.position) errors.position = "ກະລຸນາເລືອກຕຳແໜ່ງ";
      if (!values.dateOfBirth) errors.dateOfBirth = "ກະລຸນາເລືອກວັນເດືອນປີເກີດ";
      if (!values.nationality) errors.nationality = "ກະລຸນາປ້ອນສັນຊາດ";
      if (!values.tribe) errors.tribe = "ກະລຸນາປ້ອນຊົນເຜົ່າ";
      if (!values.religion) errors.religion = "ກະລຸນາປ້ອນສາດສະໜາ";
      if (!values.ready) errors.ready = "ກະລຸນາປ້ອນມື້ເລີ່ມວຽກ";
      if (!values.recruitmentNew)
        errors.recruitmentNew = "ກະລຸນາເລືອກແຫຼ່ງທີ່ມາປະກາດຮັບສະໝັກ";

      // previousSalary
      if (values.previousSalary.length > 9) {
        errors.previousSalary = "ຫ້າມໃສ່ເກີນ 10 ຕົວເລກ";
      }
      //requiredSalary
      if (!values.requiredSalary) {
        errors.requiredSalary = "ກະລຸນາປ້ອນເງິນເດືອນທີ່ຕ້ອງການ";
      } else if (values.requiredSalary.length > 9) {
        errors.requiredSalary = "ຫ້າມໃສ່ເກີນ 10 ຕົວເລກ";
      }

      if (!values.village) errors.village = "ກະລຸນາປ້ອນບ້ານເກີດ";
      if (!values.district) errors.district = "ກະລຸນາປ້ອນເມືອງ";
      if (!values.province) errors.province = "ກະລຸນາປ້ອນແຂວງ";
      if (!values.villageNew) errors.villageNew = "ກະລຸນາປ້ອນທີ່ຢູ່ປັດຈຸບັນ";
      if (!values.districtNew) errors.districtNew = "ກະລຸນາປ້ອນເມືອງປັດຈຸບັນ";
      if (!values.provinceNew) errors.provinceNew = "ກະລຸນາປ້ອນແຂວງປັດຈຸບັນ";
      /* statusPerson */
      if (
        !values.statusPerson ||
        !["MARRIED", "SINGLES", "OTHER"].includes(values.statusPerson)
      ) {
        errors.statusPerson = "ກະລຸນາເລືອກສະຖານະ";
      } else {
        delete errors.statusPerson;
      }

      // detailStatusOther
      if (values.statusPerson === "OTHER") {
        if (
          !values.detailStatusOther ||
          values.detailStatusOther.trim() === ""
        ) {
          errors.detailStatusOther = "ກະລຸນາລະບຸສະຖານະອື່ນໆ";
        }
      }
      // ຕ້ອງກອກຢ່າງນ້ອຍ 1 ກຸ່ມ
      const hasCensusGroup =
        values.censusNumber || values.censusDate || values.leaveBy;

      const hasIdCardGroup =
        values.identityCardNumber || values.dateCard || values.leaveByCard;

      if (!hasCensusGroup && !hasIdCardGroup) {
        errors.censusNumber = "ກະລຸນາປ້ອນຂໍ້ມູນ (ເລືອກຢ່າງໃດຢ່າງໜຶ່ງ)";
        errors.identityCardNumber = "ກະລຸນາປ້ອນຂໍ້ມູນ (ເລືອກຢ່າງໃດຢ່າງໜຶ່ງ)";
      }

      //  ສຳມະໂນຄົວ
      if (hasCensusGroup) {
        // ສຳມະໂນຄົວເລກທີ
        if (!values.censusNumber) {
          errors.censusNumber = "ກະລຸນາປ້ອນສຳມະໂນຄົວເລກທີ";
        }

        // ວັນທີລົງສຳມະໂນຄົວ
        if (!values.censusDate) {
          errors.censusDate = "ກະລຸນາປ້ອນຂໍ້ມູນ";
        } else if (new Date(values.censusDate) > new Date()) {
          errors.censusDate = "ວັນທີລົງສຳມະໂນຄົວບໍ່ສາມາດເປັນອະນາຄົດ";
        }

        // ຜູ້ອອກ / leaveBy
        if (!values.leaveBy) {
          errors.leaveBy = "ກະລຸນາປ້ອນຂໍ້ມູນ";
        }
      }

      //   ບັດປະຈຳຕົວ
      if (hasIdCardGroup) {
        // ເລກທີບັດປະຈຳຕົວ
        if (!values.identityCardNumber) {
          errors.identityCardNumber = "ກະລຸນາປ້ອນເລກທີບັດປະຈຳຕົວ";
        }

        // ວັນທີອອກບັດ
        if (!values.dateCard) {
          errors.dateCard = "ກະລຸນາປ້ອນຂໍ້ມູນ";
        } else if (new Date(values.dateCard) > new Date()) {
          errors.dateCard = "ວັນທີອອກບັດປະຈຳຕົວບໍ່ສາມາດເປັນອະນາຄົດ";
        }

        // ຜູ້ອອກບັດ / leaveByCard
        if (!values.leaveByCard) {
          errors.leaveByCard = "ກະລຸນາປ້ອນຂໍ້ມູນ";
        }
      }

      if (!values.reasontobecome)
        errors.reasontobecome = "ກະລຸນາປ້ອນເຫດຜົນທີ່ຢາກເຂົ້າເຮັດວຽກ";
      if (!values.relativeBy) errors.relativeBy = "ກະລຸນາປ້ອນຊື່ ແລະ ນາມສະກຸນ";
      if (!values.relationship) errors.relationship = "ກະລຸນາປ້ອນສາຍພົວພັນ";
      /* relativePhone */
      if (!values.relativePhone) {
        errors.relativePhone = "ກະລຸນາປ້ອນເບີໂທຕິດຕໍ່";
      } else if (!/^\d+$/.test(values.relativePhone)) {
        errors.relativePhone = "ເບີໂທຕ້ອງເປັນຕົວເລກເທົ່ານັ້ນ";
      } else if (!/^\d{8,12}$/.test(values.relativePhone)) {
        errors.relativePhone = "ເບີໂທບຸກຄົນຕິດຕໍ່ບໍ່ຖືກຮູບແບບ (8-12 ໂຕເລກ)";
      }

      if (!values.relativeVillage)
        errors.relativeVillage = "ກະລຸນາປ້ອນທີ່ຢູ່ປັດຈຸບັນ";
      if (!values.relativeDistrict) errors.relativeDistrict = "ກະລຸນາປ້ອນເມືອງ";
      if (!values.relativeProvince) errors.relativeProvince = "ກະລຸນາປ້ອນແຂວງ";

      //  ===== ພາສາ ແລະ ຄອມພິວເຕີ້ =====
      const hasComputerSkills = values.computerSkills;
      const hasLanguageSkills =
        values.englishSkills && values.chineseSkills && values.vietnamSkills;
      if (!hasLanguageSkills) {
        errors.skills = "ກະລຸນາເລືອກໃຫ້ຄົບປະເພດ";
      }
      if (!hasComputerSkills) {
        errors.computerSkills = "ກະລຸນາເລືອກທັກສະຄອມພິວເຕີ້";
      }

      return errors;
    },
    onSubmit: async (values) => {
      try {
        const educationLevelString = formatEducationLevelString(
          values.educationLevel || []
        );
        const previousPlaceOfWorkString = formatPreviousWorkString(
          values.previousPlaceOfWork || []
        );
        const toNumberOrNull = (v) => {
          if (v === "" || v == null) return null;
          const num = Number(v);
          if (isNaN(num)) return null;
          return num;
        };
        const toFilenameOnly = (val) => {
          if (!val) return "";
          return String(val).split("/").pop();
        };
        const payload = {
          firstName: values.firstName,
          lastName: values.lastName,
          phoneNumber: toNumberOrNull(values.phoneNumber),
          profileImage: toFilenameOnly(imagePR),
          files: toFilenameOnly(imageCV),
          dateOfBirth: values.dateOfBirth,
          description: values.description,
          position: values.position,
          educationLevel: educationLevelString,
          previousPlaceOfWork: previousPlaceOfWorkString,
          computerSkills: values.computerSkills,
          otherComputerSkills: values.otherComputerSkills,
          englishSkills: values.englishSkills,
          chineseSkills: values.chineseSkills,
          vietnamSkills: values.vietnamSkills,
          otherSkills: values.otherSkills,
          nationality: values.nationality,
          tribe: values.tribe,
          religion: values.religion,
          ready: values.ready,
          recruitmentNew: values.recruitmentNew,

          previousSalary: Number(values.previousSalary),
          requiredSalary: Number(values.requiredSalary),

          village: values.village,
          district: values.district,
          province: values.province,
          villageNew: values.villageNew,
          districtNew: values.districtNew,
          provinceNew: values.provinceNew,
          statusPerson: values.statusPerson,
          detailStatusOther: values.detailStatusOther,

          censusNumber: values.censusNumber,
          censusDate: values.censusDate,
          leaveBy: values.leaveBy,

          identityCardNumber: values.identityCardNumber,
          dateCard: values.dateCard,
          leaveByCard: values.leaveByCard,

          reasontobecome: values.reasontobecome,
          specialSkillOther: values.specialSkillOther,
          relativeBy: values.relativeBy,
          relationship: values.relationship,
          relativePhone: values.relativePhone,
          relativeVillage: values.relativeVillage,
          relativeDistrict: values.relativeDistrict,
          relativeProvince: values.relativeProvince,
        };

        Object.keys(payload).forEach((key) => {
          const v = payload[key];
          const isEmptyString = v === "" || v === "null";
          const isNullish = v === null || v === undefined;
          if (isEmptyString || isNullish) {
            delete payload[key];
          }
        });
        /* console.log("payload", payload);
        console.log("values", values);
        return; */
        await addData({
          variables: {
            data: payload,
          },
        });

        Notiflix.Loading.remove();
        messageSuccess("ບັນທຶກສຳເລັດ");
        resetForm();
        setImagePR("");
        setImageCV("");
        setFile("");
        setSalaryPrevDisplay("");
        setSalaryReqDisplay("");
      } catch (error) {
        console.log(error);
        Notiflix.Loading.remove();
        messageError("ການເພີ່ມຂໍ້ມູນຜິດພາດ");
      }
    },
  });

  // "1.000.000"
  const handlePrevSalaryChange = (e) => {
    const rawDigits = e.target.value.replace(/\D/g, "");
    setSalaryPrevDisplay(formatSalary(rawDigits));
    setFieldValue("previousSalary", rawDigits);
  };

  const handleReqSalaryChange = (e) => {
    const rawDigits = e.target.value.replace(/\D/g, "");
    setSalaryReqDisplay(formatSalary(rawDigits));
    setFieldValue("requiredSalary", rawDigits);
  };

  const onSubmitClick = async (e) => {
    e.preventDefault();
    try {
      const errs = await validateForm(values);
      if (errs && Object.keys(errs).length > 0) {
        setTouched(
          Object.fromEntries(Object.keys(errs).map((k) => [k, true])),
          true
        );
        Notiflix.Report.warning(
          "ຂໍ້ມູນບໍ່ຄົບ",
          "ກະລຸນາກວດແລະກອກຂໍ້ມູນໃຫ້ຄົບກ່ອນສົ່ງຟອມ",
          "ຮູ້ແລ້ວ"
        );
        requestAnimationFrame(() => {
          const firstErrorEl = document.querySelector(".error-text");
          if (firstErrorEl && firstErrorEl.scrollIntoView) {
            firstErrorEl.scrollIntoView({
              behavior: "smooth",
              block: "center",
            });
          }
        });
        return;
      }
      handleSubmit();
    } catch (e2) {
      console.error(e2);
      Notiflix.Notify.failure("ມີບັນຫາໃນການກວດສອບຟອມ");
    }
  };

  const handleDownload = () => {
    const link = document.createElement("a");
    link.href = PDF_REGISTER;
    link.download = "P-HR-014ໃບສະຫມັກວຽກ.pdf";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const inputStyle = {
    width: "100%",
    padding: "0.70rem",
    border: "1px solid #909191b6",
    borderRadius: "0.5rem",
    fontSize: "1rem",
    outline: "none",
    transition: "border-color 0.3s",
  };

  const labelStyle = {
    fontSize: "0.875rem",
    fontWeight: "500",
    marginBottom: "0.5rem",
    display: "block",
    color: "#374151",
  };

  const handleStatusChange = (e) => {
    const newStatus = e.target.value;
    setFieldValue("statusPerson", newStatus);
    if (newStatus !== "OTHER") {
      setFieldValue("detailStatusOther", "");
    }
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        padding: "2rem 1rem",
        backgroundImage: `linear-gradient(rgba(255, 255, 255, 0.85), rgba(138, 136, 136, 0.85)), url(${background})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
    >
      <div
        style={{ maxWidth: "800px", margin: "0 auto" }}
        className="shadow-lg"
      >
        {/* Header */}
        <div
          style={{
            padding: "3rem 2rem",
            borderRadius: "1rem 1rem 0 0",
            textAlign: "center",
          }}
          className="my-gradient-box"
        >
          <img
            src={logo_next_day}
            alt="Anousith Express"
            style={{
              width: "140px",
              objectFit: "contain",
              display: "block",
              margin: "0 auto 1.25rem",
              filter: "drop-shadow(0 2px 3px rgba(0,0,0,0.25))",
            }}
          />
          <h1
            style={{
              fontSize: "1.8rem",
              fontWeight: "700",
              color: "white",
              marginBottom: "0.25rem",
            }}
          >
            ຟອມສະໝັກເຂົ້າເຮັດວຽກ
          </h1>

          <p
            style={{
              fontSize: "1rem",
              color: "#fee2e2",
              margin: 0,
              letterSpacing: "0.5px",
            }}
          >
            ບໍລິສັດ ອານຸສິດ ຂົນສົ່ງດ່ວນ
          </p>
        </div>

        {/* Form */}
        <div
          className="mt-0"
          style={{
            background: "rgba(255, 255, 255, 0.95)",
            padding: "1rem",
            border: "1px solid #e5e7eb",
            borderRadius: "0 0 1rem 1rem",
          }}
        >
          {/* Profile Image */}
          <div
            style={{
              textAlign: "center",
              marginBottom: "2rem",
              position: "relative",
            }}
          >
            <input
              type="file"
              id="profile-upload"
              onChange={handleChangeFileProfile}
              accept="image/*"
              style={{ display: "none" }}
            />
            <label
              htmlFor="profile-upload"
              style={{
                cursor: "pointer",
                display: "inline-block",
                position: "relative",
              }}
            >
              {imagePR ? (
                <div
                  style={{
                    position: "relative",
                    width: "130px",
                    height: "130px",
                    borderRadius: "50%",
                    overflow: "hidden",
                    border: "3px solid #dc2626",
                    boxShadow: "0 4px 15px rgba(0,0,0,0.25)",
                    transition: "transform 0.3s ease, box-shadow 0.3s ease",
                    backgroundColor: "#f9fafb",
                  }}
                >
                  <img
                    src={url_path_files + imagePR}
                    alt="Profile"
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                      objectPosition: "center",
                      borderRadius: "50%",
                    }}
                  />
                  {/* overlay edit icon */}
                  <div
                    style={{
                      position: "absolute",
                      bottom: 0,
                      width: "100%",
                      height: "40%",
                      background: "rgba(0,0,0,0.4)",
                      color: "white",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      opacity: 0,
                      transition: "opacity 0.3s ease",
                    }}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      style={{
                        width: "1.6rem",
                        height: "1.6rem",
                        color: "white",
                      }}
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M15.232 5.232l3.536 3.536M9 13l6-6m2 2l-6 6m0 0H5v4h4v-4z"
                      />
                    </svg>
                  </div>
                </div>
              ) : (
                <div
                  style={{
                    width: "130px",
                    height: "130px",
                    borderRadius: "50%",
                    border: "3px dashed #dc2626",
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                    background: "#fef2f2",
                    transition: "all 0.3s ease",
                  }}
                >
                  <svg
                    style={{
                      width: "3.8rem",
                      height: "3.8rem",
                      color: "#dc2626",
                    }}
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M3 9a2 2 0 012-2h.93a2 2 0 001.664-.89l.812-1.22A2 2 0 0110.07 4h3.86a2 2 0 011.664.89l.812 1.22A2 2 0 0018.07 7H19a2 2 0 012 2v9a2 2 0 01-2 2H5a2 2 0 01-2-2V9z"
                    />
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M15 13a3 3 0 11-6 0 3 3 0 016 0z"
                    />
                  </svg>
                </div>
              )}
              <p
                style={{
                  marginTop: "0.75rem",
                  fontSize: "0.9rem",
                  color: "#6b7280",
                }}
              >
                {imagePR ? "ປ່ຽນຮູບໂປຣໄຟລ໌" : "ອັບໂຫຼດຮູບໂປຣໄຟລ໌"}
              </p>
            </label>
          </div>

          {/* ຂໍ້ມູນພື້ນຖານຫຼັກ */}
          <BasicInfoSection
            values={values}
            errors={errors}
            handleChange={handleChange}
            labelStyle={labelStyle}
            inputStyle={inputStyle}
            salaryPrevDisplay={salaryPrevDisplay}
            salaryReqDisplay={salaryReqDisplay}
            handlePrevSalaryChange={handlePrevSalaryChange}
            handleReqSalaryChange={handleReqSalaryChange}
            handleStatusChange={handleStatusChange}
          />
          <hr className="m-1 mt-4" style={{ border: "2px solid red" }} />

          {/* ຂໍ້ມູນຕົວຕົນ ແລະ ສາເຫດໃນການສະໝັກ */}
          <IdentityAndReasonSection
            values={values}
            errors={errors}
            handleChange={handleChange}
            labelStyle={labelStyle}
            inputStyle={inputStyle}
          />

          <hr className="m-1 mt-4" style={{ border: "2px solid red" }} />

          {/* ຕາຕະລາງ */}
          <ExtraTables
            values={values}
            handleChange={handleChange}
            labelStyle={labelStyle}
            inputStyle={inputStyle}
            errors={errors}
          />

          <hr className="m-1 mt-4" style={{ border: "2px solid red" }} />

          {/* ບຸກຄົນທີ່ຕິດຕໍ່ໄດ້ໃນກໍລະນີສຸກເສີນ */}
          <RelativeContactSection
            values={values}
            errors={errors}
            handleChange={handleChange}
            labelStyle={labelStyle}
            inputStyle={inputStyle}
          />

          {/* CV Upload */}
          <div style={{ marginTop: "1.5rem" }}>
            <label style={labelStyle}>
              ອັບໂຫຼດເອກະສານ CV
              {errors.files && (
                <>
                  <span style={{ color: "red", marginLeft: 4 }}>*</span>
                </>
              )}
            </label>
            <input
              type="file"
              id="cv-upload"
              onChange={handleChangeFile}
              accept="application/pdf,image/*"
              style={{ display: "none" }}
            />
            <label
              htmlFor="cv-upload"
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                padding: "2rem",
                border: "2px dashed #d1d5db",
                borderRadius: "0.5rem",
                cursor: "pointer",
                background: "#f9fafb",
              }}
            >
              {!imageCV ? (
                <div style={{ textAlign: "center" }}>
                  <svg
                    style={{
                      width: "4rem",
                      height: "4rem",
                      margin: "0 auto",
                      color: "#f53349ff",
                    }}
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12"
                    />
                  </svg>
                  <p style={{ marginTop: "0.75rem" }}>ຄລິກເພື່ອອັບໂຫຼດ CV</p>
                  <p className="error-text">PDF, PNG, JPG</p>
                </div>
              ) : (
                <div style={{ textAlign: "center" }}>
                  <svg
                    style={{
                      width: "4rem",
                      height: "4rem",
                      margin: "0 auto",
                      color: "#4ade80",
                    }}
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                    />
                  </svg>
                  <p
                    style={{
                      marginTop: "0.75rem",
                      color: "#86efac",
                      fontWeight: "500",
                    }}
                  >
                    {getFile}
                  </p>
                </div>
              )}
            </label>
            {errors.files && !imageCV && (
              <p
                className="error-text"
                style={{ color: "#dc2626", marginTop: "4px" }}
              >
                {errors.files}
              </p>
            )}
          </div>
          {/* Description */}
          <div style={{ marginTop: "1.5rem" }}>
            <label style={labelStyle}>ອືນໆ (ຖ້າມີ)</label>
            <textarea
              name="description"
              value={values.description}
              onChange={handleChange}
              rows={4}
              style={{ ...inputStyle, resize: "vertical" }}
              placeholder="ບອກພວກເຮົາເພີ່ມເຕີມກ່ຽວກັບຕົວທ່ານເອງ..."
            />
          </div>
          {/* Download Button */}
          <button
            onClick={handleDownload}
            className="download-btn"
            title="ດາວໂຫຼດແບບຟອມ"
          >
            <svg
              style={{ width: "1.5rem", height: "1.5rem", color: "white" }}
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
              />
            </svg>
            <span>ດາວໂຫຼດແບບຟອມ</span>
          </button>

          {/* Submit Button */}
          <button
            type="button"
            onClick={onSubmitClick}
            disabled={isSubmitting}
            style={{
              width: "100%",
              padding: "1rem",
              marginTop: "1.5rem",
              background: "#dc2626",
              color: "white",
              fontWeight: "600",
              borderRadius: "0.5rem",
              border: "none",
              cursor: isSubmitting ? "not-allowed" : "pointer",
              fontSize: "1rem",
              opacity: isSubmitting ? 0.6 : 1,
            }}
          >
            {isSubmitting ? "ກຳລັງສົ່ງ..." : "ຢືນຢັນສົ່ງຟອມ"}
          </button>
          <style>{`
            @keyframes float {
              0% { transform: translatey(0); }
              50% { transform: translatey(-10px); }
              100% { transform: translatey(0); }
            }
          `}</style>
        </div>
      </div>
    </div>
  );
}
